import { createHttpEndpoint } from '../../utils'

import type {
  GetHyperwalletAccessToken,
  GetHyperwalletKybUrl,
  GetHyperwalletTransferMethodsUrl,
} from './hyperwallet.types'

/**
 * Generate an access token to authenticate the merchant on Hyperwallet.
 *
 * @see {@link https://devportal.backmarket.io/catalog/default/api/seller-merchants-api/definition#tag/Hyperwallet/operation/get-bm-merchants-hyperwallet-generate-access-token}
 */
export const getHyperwalletAccessToken =
  createHttpEndpoint<GetHyperwalletAccessToken>({
    method: 'GET',
    operationId: 'getAccessToken',
    path: '/bm/merchants/hyperwallet/generate-access-token',
  })

/**
 * Generate a KYB drop-in URL linking to an Hyperwallet JavaScript script.
 *
 * @see {@link https://devportal.backmarket.io/catalog/default/api/seller-merchants-api/definition#tag/Hyperwallet/operation/get-bm-merchants-hyperwallet-kyb-generate-drop-in-url }
 */
export const getHyperwalletKybUrl = createHttpEndpoint<GetHyperwalletKybUrl>({
  method: 'GET',
  operationId: 'getKybUrl',
  path: '/bm/merchants/hyperwallet/kyb/generate-drop-in-url',
})

/**
 * Generate a transfer methods drop-in URL linking to an Hyperwallet JavaScript script.
 *
 * @see {@link https://devportal.backmarket.io/catalog/default/api/seller-merchants-api/definition#tag/Hyperwallet/operation/get-bm-merchants-hyperwallet-transfer-methods-generate-drop-in-url}
 */
export const getHyperwalletTransferMethodsUrl =
  createHttpEndpoint<GetHyperwalletTransferMethodsUrl>({
    method: 'GET',
    operationId: 'getTransferMethodsUrl',
    path: '/bm/merchants/hyperwallet/transfer-methods/generate-drop-in-url',
  })

/**
 * Submit transfer methods Hyperwallet response
 *
 * @see {@link https://devportal.backmarket.io/catalog/default/api/seller-merchants-api/definition#tag/Hyperwallet/operation/post-bm-merchants-hyperwallet-transfer-methods-submit-hyperwallet-response}
 */
export const postHyperwalletTransferMethod = createHttpEndpoint({
  method: 'POST',
  operationId: 'submitTransferMethods',
  path: '/bm/merchants/hyperwallet/transfer-methods/submit-hyperwallet-response',
})
